import createReducer from './reducers';
import getTypes from './types';
import getActions from './actions';
import getSelectors from './selectors';
import metadataAdapter from './metadataAdapter';
import createSagaFor, { isRequired, showErrors } from './saga';
import { afterInitializeReduce, cleanPhoneNumber, dtoBuilder, metadataConverter } from './helpers';

const createAction = (storeName, type, payload) => ({
    type: `${storeName}.${type}`,
    payload: payload
        ? Object.entries(payload).reduce(
              (acc, [name, value]) => (value !== undefined ? { ...acc, [name]: value } : acc),
              {},
          )
        : null,
});

export {
    createAction,
    createReducer,
    getTypes,
    getActions,
    getSelectors,
    createSagaFor,
    dtoBuilder,
    showErrors,
    metadataConverter,
    isRequired,
    metadataAdapter,
    cleanPhoneNumber,
};

export default {
    createAction,
    createReducer,
    getTypes,
    getActions,
    getSelectors,
    createSagaFor,
    dtoBuilder,
    showErrors,
    metadataConverter,
    isRequired,
    metadataAdapter,
    afterInitializeReduce,
};
